/* aff48dfc94d11b93ba7a4400daac76232be4a1cc
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HomepagePostsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HomepagePostsQuery = { __typename?: 'Query', homepagePosts?: { __typename?: 'HomepagePosts', items?: Array<{ __typename?: 'Post', comment_status?: string | null, guid?: string | null, id?: string | null, post_content?: string | null, post_date?: string | null, post_excerpt?: string | null, post_modified?: string | null, post_modified_gmt?: string | null, post_name?: string | null, post_status?: string | null, post_title?: string | null, post_type?: string | null, post_url?: string | null, thumb_img?: string | null, author?: string | null, views_count?: number | null } | null> | null } | null };

export type UsefulInformationItemFragment = { __typename?: 'Post', comment_status?: string | null, guid?: string | null, id?: string | null, post_content?: string | null, post_date?: string | null, post_excerpt?: string | null, post_modified?: string | null, post_modified_gmt?: string | null, post_name?: string | null, post_status?: string | null, post_title?: string | null, post_type?: string | null, post_url?: string | null, thumb_img?: string | null, author?: string | null, views_count?: number | null };

export type CategoryPostsQueryVariables = Types.Exact<{
  categoryId: Types.Scalars['Int']['input'];
}>;


export type CategoryPostsQuery = { __typename?: 'Query', categoryPosts?: { __typename?: 'CategoryPosts', items?: Array<{ __typename?: 'Post', comment_status?: string | null, guid?: string | null, id?: string | null, post_content?: string | null, post_date?: string | null, post_excerpt?: string | null, post_modified?: string | null, post_modified_gmt?: string | null, post_name?: string | null, post_status?: string | null, post_title?: string | null, post_type?: string | null, post_url?: string | null, thumb_img?: string | null, author?: string | null, views_count?: number | null } | null> | null } | null };

export type ProductPostsQueryVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type ProductPostsQuery = { __typename?: 'Query', productPosts?: { __typename?: 'ProductPosts', items?: Array<{ __typename?: 'Post', comment_status?: string | null, guid?: string | null, id?: string | null, post_content?: string | null, post_date?: string | null, post_excerpt?: string | null, post_modified?: string | null, post_modified_gmt?: string | null, post_name?: string | null, post_status?: string | null, post_title?: string | null, post_type?: string | null, post_url?: string | null, thumb_img?: string | null, author?: string | null, views_count?: number | null } | null> | null } | null };

export const UsefulInformationItemFragmentDoc = gql`
    fragment UsefulInformationItem on Post {
  comment_status
  guid
  id
  post_content
  post_date
  post_excerpt
  post_modified
  post_modified_gmt
  post_name
  post_status
  post_title
  post_type
  post_url
  thumb_img
  author
  views_count
}
    `;
export const HomepagePostsDocument = gql`
    query HomepagePosts {
  homepagePosts {
    items {
      ...UsefulInformationItem
    }
  }
}
    ${UsefulInformationItemFragmentDoc}`;

/**
 * __useHomepagePostsQuery__
 *
 * To run a query within a React component, call `useHomepagePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomepagePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomepagePostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomepagePostsQuery(baseOptions?: Apollo.QueryHookOptions<HomepagePostsQuery, HomepagePostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomepagePostsQuery, HomepagePostsQueryVariables>(HomepagePostsDocument, options);
      }
export function useHomepagePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomepagePostsQuery, HomepagePostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomepagePostsQuery, HomepagePostsQueryVariables>(HomepagePostsDocument, options);
        }
export function useHomepagePostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomepagePostsQuery, HomepagePostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomepagePostsQuery, HomepagePostsQueryVariables>(HomepagePostsDocument, options);
        }
export type HomepagePostsQueryHookResult = ReturnType<typeof useHomepagePostsQuery>;
export type HomepagePostsLazyQueryHookResult = ReturnType<typeof useHomepagePostsLazyQuery>;
export type HomepagePostsSuspenseQueryHookResult = ReturnType<typeof useHomepagePostsSuspenseQuery>;
export type HomepagePostsQueryResult = Apollo.QueryResult<HomepagePostsQuery, HomepagePostsQueryVariables>;
export const CategoryPostsDocument = gql`
    query CategoryPosts($categoryId: Int!) {
  categoryPosts(category_id: $categoryId) {
    items {
      ...UsefulInformationItem
    }
  }
}
    ${UsefulInformationItemFragmentDoc}`;

/**
 * __useCategoryPostsQuery__
 *
 * To run a query within a React component, call `useCategoryPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryPostsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryPostsQuery(baseOptions: Apollo.QueryHookOptions<CategoryPostsQuery, CategoryPostsQueryVariables> & ({ variables: CategoryPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryPostsQuery, CategoryPostsQueryVariables>(CategoryPostsDocument, options);
      }
export function useCategoryPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryPostsQuery, CategoryPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryPostsQuery, CategoryPostsQueryVariables>(CategoryPostsDocument, options);
        }
export function useCategoryPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CategoryPostsQuery, CategoryPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryPostsQuery, CategoryPostsQueryVariables>(CategoryPostsDocument, options);
        }
export type CategoryPostsQueryHookResult = ReturnType<typeof useCategoryPostsQuery>;
export type CategoryPostsLazyQueryHookResult = ReturnType<typeof useCategoryPostsLazyQuery>;
export type CategoryPostsSuspenseQueryHookResult = ReturnType<typeof useCategoryPostsSuspenseQuery>;
export type CategoryPostsQueryResult = Apollo.QueryResult<CategoryPostsQuery, CategoryPostsQueryVariables>;
export const ProductPostsDocument = gql`
    query ProductPosts($productId: Int!) {
  productPosts(product_id: $productId) {
    items {
      ...UsefulInformationItem
    }
  }
}
    ${UsefulInformationItemFragmentDoc}`;

/**
 * __useProductPostsQuery__
 *
 * To run a query within a React component, call `useProductPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPostsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductPostsQuery(baseOptions: Apollo.QueryHookOptions<ProductPostsQuery, ProductPostsQueryVariables> & ({ variables: ProductPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPostsQuery, ProductPostsQueryVariables>(ProductPostsDocument, options);
      }
export function useProductPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPostsQuery, ProductPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPostsQuery, ProductPostsQueryVariables>(ProductPostsDocument, options);
        }
export function useProductPostsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPostsQuery, ProductPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPostsQuery, ProductPostsQueryVariables>(ProductPostsDocument, options);
        }
export type ProductPostsQueryHookResult = ReturnType<typeof useProductPostsQuery>;
export type ProductPostsLazyQueryHookResult = ReturnType<typeof useProductPostsLazyQuery>;
export type ProductPostsSuspenseQueryHookResult = ReturnType<typeof useProductPostsSuspenseQuery>;
export type ProductPostsQueryResult = Apollo.QueryResult<ProductPostsQuery, ProductPostsQueryVariables>;